import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-resident-customer-list-filter',
	templateUrl: './resident-customer-list-filter.component.html',
	styleUrls: ['./resident-customer-list-filter.component.css'],
})
export class ResidentCustomerListFilterComponent extends FiltersComponent {
	@Input() destinations: Array<any> = [];
	@Input() products: Array<any> = [];
	filters = {
		destination: null,
		products: null,
		dateFrom: null,
		dateTo: null,
	};
	isProduction = environment.production;

	protected filtersDefinition: {
		products: {
			type: 'string';
			isArray: true;
		};
	};
}
